export const template2: SimpleProjectServiceAPI.ConfigurationDataDto = {
  root: '7de0765e-fa09-4fdd-9239-c10b727554b5',
  storeId: '601a7c6365fb000bda0cfeb8',
  articles: [
    {
      id: '7de0765e-fa09-4fdd-9239-c10b727554b5',
      number: '920024 2000',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      number: '928010 481',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '0a6096cb-8fbc-4686-ae6d-176af9008b2d',
      number: '928230 2000/AB1',
      colors: [],
      requiredLightingArticlesIds: [],
    },
    {
      id: 'cde789cf-7de7-41c8-93d7-e600a07b425a',
      number: '928140 2000',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [
        '68d0272c-05c1-4707-888f-b8244e0c8406',
        '2a01d39b-3eb9-424c-923b-2ba0271e9bb1',
      ],
    },
    {
      id: '6f3fe32b-1786-43bf-aa6d-baf424440c69',
      number: '927300 400/4',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
        {
          ralValue: 'RAL 7016',
          affectedMaterial: 'config_ral_secondary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: 'fd6f2482-8b5b-49f4-a344-b6ee7bc4a209',
      number: '927300 400/4',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
        {
          ralValue: 'RAL 7016',
          affectedMaterial: 'config_ral_secondary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
  ],
  slots: [
    {
      id: '60490dbd-4529-494e-816a-80ab576a547a',
      type: 'PAIR',
      parentId: '7de0765e-fa09-4fdd-9239-c10b727554b5',
      name: 'supportColumnBase',
      childId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
    },
    {
      id: 'cdaa0629-1977-4327-a3fd-772be35c5cdc',
      type: 'SINGLE',
      parentId: '7de0765e-fa09-4fdd-9239-c10b727554b5',
      name: 'tableSidePlate',
      alignment: 'left',
    },
    {
      id: 'f6f7306e-c4b5-4229-83e0-705f61ecd00a',
      type: 'SINGLE',
      parentId: '7de0765e-fa09-4fdd-9239-c10b727554b5',
      name: 'structureDividerBase',
      xIndex: 0,
      alignment: null,
    },
    {
      id: '421f9072-2d43-4604-9a1d-cd1f30bfb8c1',
      type: 'SINGLE',
      parentId: '7de0765e-fa09-4fdd-9239-c10b727554b5',
      name: 'structureDividerBase',
      xIndex: 1,
      alignment: null,
    },
    {
      id: 'b6318a23-401e-4b36-abb8-20fe1ee0f09d',
      type: 'SINGLE',
      parentId: '7de0765e-fa09-4fdd-9239-c10b727554b5',
      name: 'structureDividerBase',
      xIndex: 2,
      alignment: null,
    },
    {
      id: 'afb8eeb6-2848-4bfc-b739-275bba763397',
      type: 'SINGLE',
      parentId: '7de0765e-fa09-4fdd-9239-c10b727554b5',
      name: 'tableSidePlate',
      alignment: 'right',
    },
    {
      id: '7ca9b4eb-8ced-4aaa-a9b1-6fed5bf67757',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'rearPanel',
      alignment: null,
    },
    {
      id: 'a0041460-e572-49af-a130-a3a06360af60',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'leftColumnSuspension',
      childId: 'cde789cf-7de7-41c8-93d7-e600a07b425a',
      xIndex: 8,
      alignment: null,
    },
    {
      id: 'f46be679-c71f-4374-9406-5ba7030789ef',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'leftColumnSuspension',
      childId: '0a6096cb-8fbc-4686-ae6d-176af9008b2d',
      xIndex: 1,
      alignment: null,
    },
    {
      id: '6368ef73-c55b-4d2a-8592-c696847cc3a7',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'columnMediaModule',
      xIndex: 0,
      alignment: 'right',
    },
    {
      id: 'a42917e9-1c87-4bdd-940d-ea9b12815e6b',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      blockedBy: '0a6096cb-8fbc-4686-ae6d-176af9008b2d',
      name: 'rightColumnSuspension',
      xIndex: 1,
      alignment: null,
    },
    {
      id: '6b0102b9-3c34-46f0-aba6-cf9a494023d9',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      blockedBy: '0a6096cb-8fbc-4686-ae6d-176af9008b2d',
      name: 'leftColumnSuspension',
      xIndex: 0,
      alignment: null,
    },
    {
      id: '3344ed77-91c2-4379-87a2-4b25e6f84e06',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      blockedBy: '0a6096cb-8fbc-4686-ae6d-176af9008b2d',
      name: 'rightColumnSuspension',
      xIndex: 0,
      alignment: null,
    },
    {
      id: '24301f0c-d673-44b9-a086-f00e30dbaaf4',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'columnMediaModule',
      xIndex: 0,
      alignment: 'left',
    },
    {
      id: '82644b40-5ddd-42cc-97cf-a706f86e2c6a',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      blockedBy: 'cde789cf-7de7-41c8-93d7-e600a07b425a',
      name: 'rightColumnSuspension',
      xIndex: 8,
      alignment: null,
    },
    {
      id: '57918c6c-2608-4757-bd62-cde069ccb683',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'leftColumnSuspension',
      xIndex: 5,
      alignment: null,
    },
    {
      id: 'd9974e6c-0635-4274-9476-906dce456966',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'columnThreadedBushBottom',
      xIndex: 1,
      alignment: 'left',
    },
    {
      id: 'a0584bcc-2b5c-4015-ab18-a1d84e705df4',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'leftColumnSuspension',
      xIndex: 4,
      alignment: null,
    },
    {
      id: '23c5e6f6-26ac-403f-a809-fff8efb598a2',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'rightColumnSuspension',
      xIndex: 5,
      alignment: null,
    },
    {
      id: 'df8a8002-f979-4cc9-af03-4ef6c286357d',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'rightColumnSuspension',
      xIndex: 4,
      alignment: null,
    },
    {
      id: '6a4cafae-6a2d-4dc4-927f-af7534a0e44c',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'columnThreadedBushBottom',
      xIndex: 1,
      alignment: 'right',
    },
    {
      id: 'b4cbc3f1-ec85-4248-b34f-b66a54cef197',
      type: 'LINE',
      parentId: '0a6096cb-8fbc-4686-ae6d-176af9008b2d',
      name: 'multifixBottom',
      children: [],
      axis: 'X',
      length: 1934,
    },
    {
      id: '8d84ea36-e49e-415f-bf8c-053f1de2ee75',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'leftColumnSuspension',
      xIndex: 3,
      alignment: null,
    },
    {
      id: '7a665cfb-61e5-46ae-bca1-58d83141d3cb',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'rightColumnSuspension',
      xIndex: 3,
      alignment: null,
    },
    {
      id: '28e54f4f-909e-40a3-a031-20858b946321',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'leftColumnSuspension',
      xIndex: 2,
      alignment: null,
    },
    {
      id: '9a3e00b7-7a09-4959-aef0-0e803b8f579e',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'rightColumnSuspension',
      xIndex: 2,
      alignment: null,
    },
    {
      id: '0de01e36-810a-4cd7-ac05-30bc38813eb2',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      blockedBy: '0a6096cb-8fbc-4686-ae6d-176af9008b2d',
      name: 'columnThreadedBushBottom',
      xIndex: 0,
      alignment: 'left',
    },
    {
      id: '2796f19f-c690-4752-8caa-a42639416496',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      blockedBy: '0a6096cb-8fbc-4686-ae6d-176af9008b2d',
      name: 'columnThreadedBushBottom',
      xIndex: 0,
      alignment: 'right',
    },
    {
      id: '1be1f39d-8dc9-499d-bc29-e639fcb913c5',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      blockedBy: 'cde789cf-7de7-41c8-93d7-e600a07b425a',
      name: 'leftColumnSuspension',
      xIndex: 7,
      alignment: null,
    },
    {
      id: '736f969d-da83-4e08-adeb-98d1a04a0b47',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      blockedBy: 'cde789cf-7de7-41c8-93d7-e600a07b425a',
      name: 'columnThreadedBushBottom',
      xIndex: 3,
      alignment: 'right',
    },
    {
      id: '5c289cc9-02a0-44af-9ef2-36bf90766b80',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      blockedBy: 'cde789cf-7de7-41c8-93d7-e600a07b425a',
      name: 'rightColumnSuspension',
      xIndex: 7,
      alignment: null,
    },
    {
      id: '719295cd-d28b-48ad-864e-c4e29ed18a13',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'leftColumnSuspension',
      xIndex: 6,
      alignment: null,
    },
    {
      id: '24b64371-bda9-4e39-9d4e-bccbb382cf0c',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      blockedBy: 'cde789cf-7de7-41c8-93d7-e600a07b425a',
      name: 'columnThreadedBushBottom',
      xIndex: 3,
      alignment: 'left',
    },
    {
      id: '98224435-e08e-48df-bd34-9daad9502d70',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'rightColumnSuspension',
      xIndex: 6,
      alignment: null,
    },
    {
      id: 'c151e34e-b043-4ed4-9235-25aa455c4379',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'columnThreadedBushBottom',
      xIndex: 2,
      alignment: 'right',
    },
    {
      id: '2b35e06c-fa02-457e-a692-4215e783d921',
      type: 'SINGLE',
      parentId: '9ad9fadc-e2eb-45d7-9105-8da6d22141ec',
      name: 'columnThreadedBushBottom',
      xIndex: 2,
      alignment: 'left',
    },
    {
      id: '461eda5b-36e5-482d-a691-6b587c566f11',
      type: 'LINE',
      parentId: '7de0765e-fa09-4fdd-9239-c10b727554b5',
      name: 'tabletopSubstructure',
      children: [
        {
          id: 'fd6f2482-8b5b-49f4-a344-b6ee7bc4a209',
          position: 148,
        },
        {
          id: '33ad7830-9c0e-454a-9a88-0e42a65cafe8',
          position: 76.6,
        },
        {
          id: '6f3fe32b-1786-43bf-aa6d-baf424440c69',
          position: 0,
        },
      ],
      axis: 'X',
      length: 1880,
    },
  ],
  requiredConnectArticles: [],
  requiredLightingArticles: [
    {
      id: '68d0272c-05c1-4707-888f-b8244e0c8406',
      number: '928460 CUT/OUT',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      amount: 1,
    },
    {
      id: '2a01d39b-3eb9-424c-923b-2ba0271e9bb1',
      number: '928640 DE/2',
      colors: [],
      amount: 1,
    },
  ],
  rootArticleName: 'Workstation eLevel+ 2000mm',
  socketType: 'F',
  theme: {
    primaryColor: 'RAL 7035',
    secondaryColor: 'RAL 7016',
  },
  version: 5,
};
